var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "reg-form-body form-condensed",
      attrs: { id: "registrarformview" }
    },
    [
      _vm.modeloform == 1
        ? _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group highlight-addon field-regform-nome"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label has-star",
                        attrs: { for: "regform-nome" }
                      },
                      [_vm._v("Nome")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nome,
                          expression: "nome"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "text-align": "left" },
                      attrs: {
                        type: "text",
                        id: "regform-nome",
                        name: "regform-nome",
                        required: "true",
                        "aria-required": "true"
                      },
                      domProps: { value: _vm.nome },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.nome = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group highlight-addon field-regform-email"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label has-star",
                        attrs: { for: "regform-email" }
                      },
                      [_vm._v("Email")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "text-align": "left" },
                      attrs: {
                        type: "text",
                        id: "regform-email",
                        name: "regform-email",
                        required: "true",
                        "aria-required": "true"
                      },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group highlight-addon field-regform-passwd"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label has-star",
                        attrs: { for: "regform-passwd" }
                      },
                      [_vm._v("Senha")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.senha,
                          expression: "senha"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "text-align": "left" },
                      attrs: {
                        type: "password",
                        id: "regform-passwd",
                        name: "regform-passwd",
                        required: "true",
                        "aria-required": "true"
                      },
                      domProps: { value: _vm.senha },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.senha = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("password-meter", {
                      attrs: { password: _vm.senha },
                      on: { score: _vm.onScore }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group highlight-addon field-regform-confirm"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label has-star",
                        attrs: { for: "regform-confirm" }
                      },
                      [_vm._v("Confirmação de senha")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.confirmar,
                          expression: "confirmar"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        id: "regform-confirm",
                        name: "regform-confirm"
                      },
                      domProps: { value: _vm.confirmar },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.confirmar = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "form-row auth-anchor auth-anchor-normal auth-anchor-light",
                      attrs: { id: "auth-container" }
                    },
                    [
                      _c("p", { staticClass: "auth-header" }, [
                        _vm._v("Eu não sou um robô")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("p", { staticClass: "auth-texto" }, [
                          _vm._v(_vm._s(this.texto_robo))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.resposta,
                              expression: "resposta"
                            }
                          ],
                          staticClass: "form-control auth-resposta",
                          attrs: {
                            type: "text",
                            id: "regform-resposta",
                            name: "regform-resposta"
                          },
                          domProps: { value: _vm.resposta },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.resposta = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("img", {
                          staticClass: "auth-robot",
                          attrs: {
                            src: _vm.imagemRobot2,
                            width: "48px",
                            height: "48px"
                          }
                        })
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.mensagemUsuario.length > 0
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "alert-primary",
                        attrs: { role: "alert" }
                      },
                      [
                        _c(
                          "ul",
                          _vm._l(_vm.mensagemUsuario, function(msg) {
                            return _c("li", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(msg) +
                                  "\n                        "
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "pull-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg btn-rounded",
                      attrs: { id: "btnProximo" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.proximoForm.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("Próximo")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group highlight-addon field-regform-termos"
                  },
                  [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("label", { staticClass: "has-star" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.aceite,
                              expression: "aceite"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            id: "regform-termos",
                            name: "regform-termos",
                            "true-value": "S",
                            "false-value": "N"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.aceite)
                              ? _vm._i(_vm.aceite, null) > -1
                              : _vm._q(_vm.aceite, "S")
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.aceite,
                                $$el = $event.target,
                                $$c = $$el.checked ? "S" : "N"
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.aceite = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.aceite = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.aceite = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "#",
                              onclick:
                                "window.open(route('public.termos'), '_blank');"
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Declaro que li os termos do serviço"
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "help-block" })
                    ])
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.modeloform == 2
        ? _c("div", { staticClass: "panel-body auth-empresa" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group highlight-addon field-regform-cnpj"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label has-star",
                        attrs: { for: "regform-cnpj" }
                      },
                      [_vm._v("CNPJ")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cnpj,
                          expression: "cnpj"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "text-align": "left" },
                      attrs: {
                        type: "text",
                        id: "regform-cnpj",
                        name: "regform-cnpj",
                        required: "true",
                        "aria-required": "true",
                        maxlength: "18"
                      },
                      domProps: { value: _vm.cnpj },
                      on: {
                        blur: function($event) {
                          return _vm.consultaCNPJ()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.cnpj = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group highlight-addon field-regform-empresa"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label has-star",
                        attrs: { for: "regform-empresa" }
                      },
                      [_vm._v("Empresa")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nomeEmpresa,
                          expression: "nomeEmpresa"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "text-align": "left" },
                      attrs: {
                        type: "text",
                        id: "regform-empresa",
                        name: "regform-empresa",
                        required: "true",
                        "aria-required": "true",
                        maxlength: "50",
                        disabled: _vm.consultado
                      },
                      domProps: { value: _vm.nomeEmpresa },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.nomeEmpresa = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.mensagemUsuario.length > 0
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-primary",
                        attrs: { role: "alert" }
                      },
                      [
                        _c(
                          "ul",
                          _vm._l(_vm.mensagemUsuario, function(msg) {
                            return _c("li", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(msg) +
                                  "\n                        "
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "pull-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg btn-rounded",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.salvarEtapa.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("Confirmar")]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.modeloform == 4
        ? _c("div", { staticClass: "panel-body auth-empresa" }, [_vm._m(1)])
        : _vm._e(),
      _vm._v(" "),
      _vm.processando
        ? _c(
            "div",
            { staticClass: "auth-empresa text-center" },
            [_c("LoadingBar")],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          { staticClass: "form-group highlight-addon field-regform-empresa" },
          [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n                            Porque pedimos o CNPJ:\n                            "
                ),
                _c("p", [
                  _vm._v(
                    "Precisamos para gerar cobrança bancária quando você optar por continuar a utilizar os serviços"
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "panel-heading text-center" }, [
        _c("h3", { staticClass: "text-primary" }, [
          _vm._v("Registrado com sucesso")
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "text-primary" }, [
          _vm._v("Você receberá um email para validar seu cadastro.")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }